import useFetchData from "../../utils/hooks/useFetchData";
import { PrioritiesIncidents } from "../Widgets/PrioritiesIncidents";
import { SimpleAreaWidget } from "../Widgets/SimpleAreaWidget";
import { SimpleBarWidget } from "../Widgets/SimpleBarWidget";
import { TextWidget } from "../Widgets/TextWidget";
import Spinner from "../Global/Spinner";
import { HrVertical } from "../Global/HrVertical";
import { HrHorizontal } from "../Global/HrHorizontal";
import { Card } from "antd";

export const Energy = () => {
  const { data: energyData } = useFetchData("/nova_wallboards/getenergydata");
  if (energyData) {

    return (
      <>
        <div style={{ width: '33.3%' }}>
          <Card.Grid style={{ width: '100%', textAlign: 'center', height: '39%', padding: '5px' }}>
            <PrioritiesIncidents data={{
              red: energyData?.incidents.red,
              orange: energyData?.incidents.orange,
              yellow: energyData?.incidents.yellow,
            }} />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', height: '56%', padding: '5px' }}>
            <TextWidget
              number={energyData.generalConsume}
              unit="kWh"
              unitMesure="/semana"
              label="CONSUMO GERAL" />
          </Card.Grid>
        </div>
        <HrVertical />
        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '30%', padding: '5px' }}>
            <TextWidget
              number={energyData.buildingsConsume[energyData.buildingsConsume.length - 1]?.uv || 0}
              unit="kWh"
              unitMesure="/semana"
              label="CONSUMO GERAL DE LUMINÁRIAS DO CAMPUS" />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '65%', padding: '5px' }}>
            <SimpleBarWidget
              label="CONSUMO SEMANAL POR EDIFÍCIO (kWh)"
              data={energyData.buildingsConsume}
              layout="vertical"
              height="100%"
              name='kWh'
            />
          </Card.Grid>
        </div>
        <HrVertical />
        <div style={{ width: '33.3%', textAlign: 'center' }}>
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '48%', padding: '5px' }}>
            <SimpleAreaWidget
              data={energyData.yesterdayVariationConsumeChart}
              label="CONSUMO NO DIA ANTERIOR (kWh)"
              marginTop='10px'
              name='kWh' />
          </Card.Grid>
          <HrHorizontal />
          <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '48%', padding: '5px' }}>
            <SimpleAreaWidget
              data={energyData.weekVariationConsumeChart}
              label="CONSUMO DE ENERGIA (kWh)"
              marginTop='10px'
              name='kWh' />
          </Card.Grid>
        </div>
      </>
    );
  } else {
    return (
      <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </div>
    );
  }
};